import React, {useEffect, useReducer} from 'react'
import {
	HashRouter as Router,
	Switch,
	Route,
	Link
} from 'react-router-dom'
import {createTheme} from '@material-ui/core/styles'
import {ThemeProvider} from '@material-ui/styles'
import {blue} from '@material-ui/core/colors'
import Header from './components/header/Header'
import Footer from './components/footer/Footer'
import {Container} from '@material-ui/core'
import Main from './pages/main/Main'
import {CamResponse, getCamData} from './data-service'
import Loader from './components/utils/Loader'
import Detail from './pages/detail/Detail'
import Agreement from './pages/agreement/Agreement'
import Add from './components/add/Add'

const theme = createTheme({
	palette: {
		type: 'light',
		primary: {
			main: blue[500],
		}
	},
	spacing: 8
})

interface AppState {
    data: CamResponse;
    query: string;
    isPending: boolean;
    error: string;
}

const initialCamData: CamResponse = {
	cats: [],
	items: [],
	content: {
		agreement: [],
		cookieAgreement: [],
		gallery: [],
		aboutUs: [],
		wowzaKey: [],
		add: []
	},
	tags: []
}

const initialState: AppState = {
	data: initialCamData,
	query: '',
	isPending: false,
	error: ''
}

const ACTIONS = {
	SET_PENDING_STATUS: 'SET_PENDING_STATUS',
	SET_DATA: 'SET_DATA',
	SHOW_ERROR: 'SHOW_ERROR'
}

function reducer(state: AppState, action: { type: string, payload: any }) {
	switch (action.type) {
	case ACTIONS.SET_PENDING_STATUS:
		return {...state, isPending: action.payload}
	case ACTIONS.SET_DATA:
		return {...state, data: action.payload, isPending: false}
	case ACTIONS.SHOW_ERROR:
		return {...state, error: action.payload, isPending: false}
	default:
		return {...state}
	}
}


function App() {
	const [state, dispatch] = useReducer(reducer, initialState)
	const fetchCamData = async () => {
		dispatch({type: ACTIONS.SET_PENDING_STATUS, payload: true})
		try {
			const res: CamResponse = await getCamData()
			dispatch({type: ACTIONS.SET_DATA, payload: res})
		} catch (e) {
			dispatch({type: ACTIONS.SHOW_ERROR, payload: 'ERROR: ' + e.message})
		}
	}

	useEffect(() => {
		(async () => {
			await fetchCamData()
		})()
	}, [])
	return (
		<Router>
			<ThemeProvider theme={theme}>
				<Header/>
				<main>
					<Container maxWidth="md">
						{state.isPending ? <Loader padding={'200px'} /> :
							<Switch>
								<Route path="/" exact={true}>
									<Main data={state.data}/>
								</Route>
								<Route path="/stream/:id" exact={true}>
									<Detail data={state.data}/>
								</Route>
								<Route path="/agreement" exact={true}>
									<Agreement data={state.data}/>
								</Route>
							</Switch>
						}
					</Container>
				</main>
				<Footer/>
				<Add data={state.data}/>
			</ThemeProvider>
		</Router>
	)
}

export default App
